import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeleteIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 15,
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m14.224 14.504v-11.68h1.776v-1.344h-3.808v-1.184h-8.384v1.184h-3.808v1.344h1.776v11.68zm-1.36-1.344h-9.728v-10.336h9.728zm-6.448-1.792v-6.144h-1.184v6.144zm2.144 0v-6.144h-1.184v6.144zm2.16 0v-6.144h-1.2v6.144z" })
});
export default SvgDeleteIcon;
